import { GetReportsFileTypeEnum } from './ReportEnums';

export const downloadList = [
  { value: 'presentation', label: 'presentation', id: GetReportsFileTypeEnum.Power_Point },
  { value: 'document', label: 'document', id: GetReportsFileTypeEnum.Document_Word },
];
export const presentationOnly = [
  { value: 'presentation', label: 'presentation', id: GetReportsFileTypeEnum.Power_Point },
];
